import { render, staticRenderFns } from "./View1.vue?vue&type=template&id=9472c788&"
import script from "./View1.vue?vue&type=script&lang=js&"
export * from "./View1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports